import { useEffect, useState } from "react";
import "./dialog-styles.css";
import * as Dialog from "@radix-ui/react-dialog";
import { Cross2Icon } from "@radix-ui/react-icons";
import { EventBus } from "../game/EventBus";
import { EVENTS_NAME } from "../game/consts.ts";

// Sample text for the outro pages (using lorem ipsum as requested)
const outroPages = [
  "Congraulations on winning the teaser. This kind of attention to detail and can-do attitude is exactly what we'll need at DefCon. Be sure to join us and take on bigger challenges in August. Remember, this is just the beginning of your journey in the world of AI and technology. Keep pushing boundaries and exploring new horizons. We'll be looking forward to seeing you at DefCon, where more challenges await! Until then... watch your six. RoR Discord: https://discord.gg/JB9hsnsFqY",
];

function GameOutro() {
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  // Function to open the outro dialog
  const showOutro = () => {
    setOpen(true);
  };

  // Expose the showOutro function to be called from other components
  useEffect(() => {
    EventBus.on(EVENTS_NAME.showGameOutroContinued, showOutro);

    return () => {
      EventBus.removeListener(EVENTS_NAME.showGameOutroContinued);
    };
  }, []);

  const handleDone = () => {
    // Mark that the user has seen the outro
    localStorage.setItem("hasSeenGameOutro", "true");
    setOpen(false);
  };

  const handleNext = () => {
    if (currentPage < outroPages.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Create a data URL for a placeholder image
  const placeholderImageUrl = "../assets/images/Ed_lt_pixel3.png";

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="DialogOverlay" />
        <Dialog.Content
          className="DialogContent"
          style={{
            border: "2px solid var(--ro-accent)",
            color: "var(--ro-text)",
            fontFamily: "MelGame, Courier New, monospace",
          }}
        >
          <Dialog.Title
            style={{
              fontSize: "40px",
              marginBottom: "20px",
              textAlign: "center",
              color: "var(--ro-text)",
              fontStyle: "italic",
            }}
          >
            Congratulations! You've completed the challenge!
          </Dialog.Title>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "calc(100% - 100px)",
            }}
          >
            <div style={{ flex: 1, overflow: "auto", position: "relative" }}>
              {/* Placeholder image in top left */}
              <img
                src={placeholderImageUrl}
                alt="Character"
                style={{
                  float: "left",
                  width: "100px",
                  height: "100px",
                  marginRight: "15px",
                  marginBottom: "10px",
                  borderRadius: "8px",
                  border: "1px solid var(--ro-accent)",
                }}
              />

              {/* Text that wraps around the image */}
              <p
                style={{
                  margin: "0",
                  color: "var(--ro-text)",
                  lineHeight: "1.6",
                  fontSize: "20px",
                  textAlign: "justify",
                }}
              >
                {outroPages[currentPage]}
              </p>
            </div>

            {/* Navigation buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              {currentPage > 0 && (
                <button
                  onClick={handlePrevious}
                  style={{
                    backgroundColor: "var(--ro-panel-solid)",
                    color: "var(--ro-text)",
                    border: "1px solid var(--ro-accent)",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Previous
                </button>
              )}

              {currentPage < outroPages.length - 1 ? (
                <button
                  onClick={handleNext}
                  style={{
                    backgroundColor: "var(--ro-panel-solid)",
                    color: "var(--ro-text)",
                    border: "1px solid var(--ro-accent)",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Next
                </button>
              ) : (
                <button
                  onClick={handleDone}
                  style={{
                    backgroundColor: "var(--ro-accent)",
                    color: "var(--ro-panel-solid)",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Done
                </button>
              )}
            </div>
          </div>

          <Dialog.Close asChild>
            <button
              className="PopoverClose"
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
            >
              <Cross2Icon />
            </button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default GameOutro;
